import React from 'react';
import PropTypes from 'prop-types';
import ModalComponent from '../../ModalComponent';
import PersonIcon from '../PersonIcon';
import { duckify } from '../../../utils/duckify';
import { sharedPortalStudents } from '../../../ducks';
import './styles/StudentSelector.scss';
import { renderApplyGrade, renderApplyYear, renderStudentName } from '../utils/studentDisplay';

const StudentSelector = ({
  students, multiSelect, selectedStudents, setSelectedStudents, description, buttons, title
}) => {
  const handleChange = (e) => {
    const id = e.target.value;

    if (multiSelect) {
      if (selectedStudents.includes(id)) {
        setSelectedStudents(selectedStudents.filter(student => student !== id));
      } else {
        setSelectedStudents(selectedStudents.concat([id]));
      }
    } else {
      setSelectedStudents([id]);
    }
  };

  return (
    <ModalComponent
      title={title}
      buttons={buttons}
      closeText='Cancel'
    >
      <h3>{`Select ${multiSelect ? 'Students' : 'a Student'}`}</h3>
      <span>{description}</span>
      <div className='sp-select-kids'>
        {students.map(student => (
          <div className='sp-select-kid' key={`selected_student_${student.id}`}>
            <input
              className='sp-select-kid-checkbox'
              disabled={false}
              name={`selected_student_${student.id}`}
              type={multiSelect ? 'checkbox' : 'radio'}
              value={student.id}
              checked={selectedStudents.includes(student.id)}
              onChange={handleChange}
            />
            <PersonIcon personName={renderStudentName(student)} />
            <div className='sp-select-kid-grade-info'>
              {<div>{renderApplyGrade(student)}</div>}
              {<div>{renderApplyYear(student)}</div>}
            </div>
          </div>
        ))}
      </div>
    </ModalComponent>
  );
};
StudentSelector.defaultProps = {
  multiSelect: false
};
StudentSelector.propTypes = {
  multiSelect: PropTypes.bool,
  selectedStudents: PropTypes.arrayOf(PropTypes.string).isRequired,
  setSelectedStudents: PropTypes.func.isRequired,
  description: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  buttons: PropTypes.array.isRequired /* Buttons for ModalComponent */
};

const mapDucksToProps = () => ({
  students: sharedPortalStudents
});

export default duckify(mapDucksToProps, undefined, undefined)(StudentSelector);
